import { render, staticRenderFns } from "./putrecord.vue?vue&type=template&id=185a2b46&scoped=true&"
import script from "./putrecord.vue?vue&type=script&lang=js&"
export * from "./putrecord.vue?vue&type=script&lang=js&"
import style0 from "./putrecord.vue?vue&type=style&index=0&id=185a2b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a2b46",
  null
  
)

export default component.exports